import React from "react";
import omit from "@/utils/omit";
import { IconProps } from "../interface";

const IconSearch = React.forwardRef<SVGSVGElement, IconProps>((props, ref) => (
  <svg
    ref={ref}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="yfm-icon yfm-icon-search"
    {...omit(props, ["className"])}
  >
    <path d="M21 21l-4.35-4.35M19 11a8 8 0 1 1-16 0 8 8 0 0 1 16 0Z" />
  </svg>
));

IconSearch.displayName = "IconSearch";

export default IconSearch;
